import { RowItem, RowItemType } from '../../types';

export const filterVisiblePlannerRows = (
  rows: RowItem[],
  collapsedGroups: Set<string>
): RowItem[] => {
  return rows.filter(row => {
    if (row.type === RowItemType.Group) {
      return true;
    }

    if (!row.parentGroupId) {
      return true;
    }

    return !collapsedGroups.has(row.parentGroupId);
  });
};
